import { IUpdatePromoProgramParams } from "@/core/repositories/promotion/IPromoDetail.repository";
import { PromoDetail } from "@/core/entities/promotion/PromoDetail";
import {
  PromoProgramEditMode,
  promoDetailIsUpdatingAtom,
  promoProgramEditModeAtom,
  setPromoProgramEditModeAtom,
  updatePromoProgramAtom,
} from "@/store/promotion";
import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

export function usePromotionEdit() {
  const editMode = useAtomValue(promoProgramEditModeAtom);
  const isPromoProgramUpdating = useAtomValue(promoDetailIsUpdatingAtom);
  const setEditModeAction = useSetAtom(setPromoProgramEditModeAtom);
  const updatePromoProgramAction = useSetAtom(updatePromoProgramAtom);

  const setEditMode = useCallback(
    (mode: PromoProgramEditMode | null) => {
      setEditModeAction(mode);
    },
    [setEditModeAction]
  );

  const updatePromoProgram = useCallback(
    (params: IUpdatePromoProgramParams): Promise<PromoDetail> => updatePromoProgramAction(params),
    [updatePromoProgramAction]
  );

  return {
    editMode,
    setEditMode,
    isPromoProgramUpdating,
    updatePromoProgram,
  };
}
